module.exports = __webpack_public_path__ + "static/105029458_662806054577702_6795382963467630701_o_optimized-297fe05734fdd11826e30c00264285cf.jpg";